import { render, staticRenderFns } from "./IdTagLayout.vue?vue&type=template&id=75835d4f&scoped=true&"
import script from "./IdTagLayout.vue?vue&type=script&lang=ts&"
export * from "./IdTagLayout.vue?vue&type=script&lang=ts&"
import style0 from "./IdTagLayout.vue?vue&type=style&index=0&id=75835d4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75835d4f",
  null
  
)

export default component.exports